module.exports = __webpack_public_path__ + "media/images/football-faf2243ba452ece395b9bec0e01132e8.svg";